import { gql } from "@apollo/client";

export const GET_SUBDOMAIN_FOR_ACCOUNTID = gql`
query getSubdomainForAccountId($id: bigint!) {
    accountSubdomainMap(id: $id) {
    subDomain
  }
}
`

export default {
   GET_SUBDOMAIN_FOR_ACCOUNTID,
};